import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OwlModule } from 'ngx-owl-carousel';
import { ModalModule } from 'ngx-bootstrap';

import { ImageZoomModule } from '../image-zoom/image-zoom.module';

import { ImagesPresentationComponent } from './images-presentation.component';

@NgModule({
  imports: [
    CommonModule,
    OwlModule,
    ImageZoomModule,
    ModalModule.forRoot(),
  ],
  exports: [
    ImagesPresentationComponent,
  ],
  declarations: [
    ImagesPresentationComponent,
  ],
})
export class ImagesPresentationModule {
}
